"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchErrorHandler = void 0;
const rxjs_1 = require("rxjs");
require("../types");
const catchErrorHandler = (showError) => 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(error) => {
    showError(error);
    return rxjs_1.throwError(error);
};
exports.catchErrorHandler = catchErrorHandler;
//# sourceMappingURL=catchErrorHandler.js.map